export class VatRateDto {
  public id?: number;
  public code?: string;
  public description?: string;
  public type?: string;
  public sales_vat_rate?: number;
  public purchase_vat_rate?: number;
  public per_sales_vat_rate?: number;
}
